module.exports = __webpack_public_path__ + "img/2.9fde4fb5.png";